import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import dataV from "@jiaminghi/data-view";
import "amfe-flexible";
import { imgsPreloader } from "./imgPreloader";
import imgPreloaderList from "./imgPreLoaderList";
import spacesRemove from "@/plugins/spacesRemove.js";

import { createI18n } from 'vue-i18n'
import en from './langurage/en';
import zh from './langurage/zh';
 
// 组合语言包对象
const messages = {
  en,
  zh
}

const i18n = createI18n({
    legacy: false,  // 设置为 false，启用 composition API 模式
    messages,
    locale: 'zh'  // 设置默认语言
})

imgsPreloader(imgPreloaderList);

const app = createApp(App);
app.use(store);
app.use(dataV);
app.use(router);
app.use(spacesRemove);
app.use(ElementPlus);
app.use(i18n);
app.mount("#app");
